<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      :visible.sync="visible"
      :width="width"
      center>
      <div slot="title">
        <dialog-header :title="deviceDetails.name"></dialog-header>
      </div>
      <device-detail-dialog-header :alarmInfoList="alarmInfoList"
                                   :device-info="deviceInfo"></device-detail-dialog-header>
      <div  :style="{height: dialogHeight}"
           style="margin-top: 4px;padding: 10vh 0;background-color: rgba(41, 155, 255, .1);">
        <el-row style="text-align: center">
          <!--样机图片-->
          <el-col :span="12">
            <div><img :src="$ftpUrl + deviceDetails.imgUrl"></div>
            <!--噪声-->
            <div v-if="deviceDetails.detailUrl === 'Noise'">
              <div :key="item.id" style="margin-top: 10px;" v-for="item in historyData">
                {{ item.pointName }}：{{ item.pointValueName }}
              </div>
            </div>
            <!--服务器/交换机/网络存储/防火墙-->
            <div
              v-if="deviceDetails.detailUrl === 'Server' || deviceDetails.detailUrl === 'Switch'
               || deviceDetails.detailUrl === 'Storage' || deviceDetails.detailUrl === 'Firewall'">
              IP: {{ JSON.parse(deviceDetails.portProperties).IP }}
            </div>
          </el-col>
          <!--状态值-->
          <!--烟感,漏水,噪声,红外检测-->
          <el-col :span="12" class="rightCol" v-if="deviceDetails.detailUrl === 'InfraredDetection'
          || deviceDetails.detailUrl === 'Smoke' || deviceDetails.detailUrl === 'Leak' || deviceDetails.detailUrl === 'Noise'">
            <div v-if="deviceDetails.typeCnName !== 'HikInfrared'">
              <img src="../../../assets/images/device/normal.png" v-if="deviceDetails.status === 0">
              <img src="../../../assets/images/device/exception.png" v-else>
            </div>
            <div v-if="deviceDetails.typeCnName !== 'HikInfrared'"  style="margin-top: 20px;font-weight: bold">状态：
              <span v-if="deviceDetails.status === 0">正常</span>
              <span v-else>异常</span>
            </div>
            <div v-if="deviceDetails.typeCnName == 'HikInfrared'"  style="margin-top: 20px;font-weight: bold">状态：
              <span >{{HikInfraredStatusText}}</span>
            </div>
          </el-col>
          <!--温湿度-->
          <el-col :span="12" class="rightCol" style="padding-top: 2vh"
                  v-else-if="deviceDetails.detailUrl === 'TemperatureHumidity'">
            <div v-if="historyData.length > 0">
              <div :key="item.id" style="display: inline-block" v-for="item in historyData">
                <point-gauge :data="item"></point-gauge>
              </div>
            </div>
          </el-col>
          <!--服务器,交换机,网络存储,防火墙-->
          <el-col :span="12" :style="{height: pointHeight}" class="rightCol"
                  style="padding-top: 1vh;overflow: auto" v-else>
            <point-layout :point-data="historyData"/>
          </el-col>
        </el-row>
        <div v-if="deviceDetails.detailUrl === 'Firewall'">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%;height:23vh;overflow-y: auto;margin-top: 5vh;"
            >
              <el-table-column
                align="center"
                label="端口名称"
                prop="pointName">
              </el-table-column>

            </el-table>
          </el-row>
          <el-row style="margin-top: 15px;text-align: center" v-if="tableData.length">
            <el-pagination
              :current-page.sync="current"
              :page-size.sync="size"
              :total="dataTotal"
              @current-change="handleCurrentChange"
              background
              layout="prev, pager, next">
            </el-pagination>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DialogHeader from "@/components/device_details/comp/DialogHeader";
import DeviceDetailDialogHeader from "@/components/device_details/comp/DeviceDetailHeader";
import {getHistoryByDevicePoint} from "@/network/measuring-point-history";
import PointLayout from "@/components/device_details/comp/PointLayout";
import PointGauge from "@/components/device_details/comp/PointGauge";

export default {
  name: "DeviceBoxDialog",
  components: {DialogHeader, DeviceDetailDialogHeader, PointGauge, PointLayout},
  props: ['dialogVisible', 'deviceInfo', 'alarmInfoList', 'width'],
  data() {
    return {
      visible: false,
      deviceDetails: {},
      alarmList: [],
      historyData: [],
      tableData: [],
      dialogHeight: '48vh',
      pointHeight: '30vh',
      current: 1,
      size: 10,
      dataTotal: 0,
    };
  },
  watch: {
    dialogVisible: {
      handler(val) {
        this.visible = val
      }
    },
    alarmInfoList: {
      handler(val) {
        this.alarmList = val
      }
    },
    deviceInfo: {
      handler(val) {
        this.deviceDetails = val
        if (val.detailUrl === 'Firewall') {
          this.dialogHeight = '65vh'
          this.pointHeight = '20vh'
        } else {
          this.dialogHeight = '48vh'
          this.pointHeight = '30vh'
        }
        if (val.detailUrl !== 'InfraredDetection' && val.detailUrl !== 'Smoke' && val.detailUrl !== 'Leak') {
          this.getPointData();
        }
      }
    },
  },
  computed: {
    HikInfraredStatusText() {
      const statusMap = {
        '-1': '未知',
        '0': '离线',
        '1': '正常',
        '2': '故障',
        '3': '报警',
        '4': '旁路', 
      };
      return statusMap[this.deviceDetails.status] || "未知状态";
    },
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('dialogClose', this.visible)
    },
    getPointData() {
      this.historyData = []
      getHistoryByDevicePoint({
        deviceId: this.deviceDetails.id,
        pointCodes: []
      }).then(res => {
        if (res.code === 0) {
          this.historyData = res.data.filter(item => item.pointName && item.pointName.trim() !== '')
        }
      })
    },
    handleCurrentChange(val) {
      this.current = val;
      this.size = 10;
    },
  },
}
</script>

<style scoped>
.rightCol {
  border-left: 1px solid rgba(41, 155, 255, .2);
  height: 20vh;
  padding-top: 5vh
}
</style>
